"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationResult = void 0;
/**
 * Describes validation requirements, source(s), status and dates for one or more elements.
 */
var VerificationResult = /** @class */ (function () {
    function VerificationResult() {
    }
    return VerificationResult;
}());
exports.VerificationResult = VerificationResult;
